import React, { useEffect, useState, memo } from "react";
import { useDataStore, useNavStore } from "../../hooks/useNavStore";
import moment from "moment";
import useScreenWidth from "../../helper/useScreenWidth";

const Modal = memo(
  ({
    children,
    onClose,
    title,
    icon,
    showHeader = true,
    overlay = false,
    zIndex = 15,
    isTop = false,
    iconSize = 24,
    hideOverlay = false,
    isAktuelle = false,
    todayHandler = () => {},
    expandedHandler = () => {},
    activeTab = false,
    availableTabs = [],
    expanded = false,
    subHeader = null,
  }) => {
    const isDark = useDataStore((state) => state.isDark);
    const screenWidth = useScreenWidth();

    const isMobile = screenWidth < 1100;

    const todayDate = moment().format("DD.MM.YYYY");

    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          console.log("escape!");
          onClose();
        }
      };

      document.addEventListener("keydown", handleKeyDown);

      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [onClose]);

    const overlayBlur = overlay
      ? {
          backgroundColor: isDark
            ? "rgba(27, 27, 27, 0.6)"
            : "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(2px)",
          zIndex,
        }
      : { zIndex };

    return (
      <div
        className={`${!hideOverlay ? "modal-overlay" : ""}`}
        onClick={onClose}
        style={overlayBlur}
      >
        <div
          className={`modal-content thin-scrollbar ${isTop ? "top" : ""} ${
            isDark ? "black" : ""
          } ${isMobile ? "mob" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          {showHeader && (
            <div
              className={`flex items-center justify-between  p-4 modal-header w-full ${
                subHeader && "py-1"
              }`}
            >
              <div className="flex items-center">
                {icon && (
                  <i
                    className={`icon-ns ns-${icon} w-${iconSize} h-${iconSize} flex-shrink-0 cursor-pointer mr-2`}
                  ></i>
                )}
                <p className="forgotten-bold gradient-text">{title}</p>

                {isAktuelle && availableTabs.length > 0 && (
                  <div className="switch-container select-none">
                    <div className="switch-button">
                      {availableTabs.length <= 2
                        ? availableTabs.map((tab) => (
                            <div
                              key={tab}
                              className={`switch-option ${
                                activeTab === tab ? "active" : ""
                              }`}
                              onClick={() => todayHandler(tab)}
                            >
                              {tab === "today" ? "Heute" : "Morgen (Vorschau)"}
                            </div>
                          ))
                        : availableTabs.map((tab) => {
                            const deDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
                            let label;
                            if (tab === "today") {
                              label = "Heute";
                            } else {
                              const dayIndex = tab === "tomorrow" ? 1 : parseInt(tab.replace("day_", ""), 10);
                              const date = moment().add(dayIndex, "days");
                              label = `${deDays[date.day()]} ${date.format("DD.MM")}`;
                            }
                            return (
                              <div
                                key={tab}
                                className={`switch-option ${
                                  activeTab === tab ? "active" : ""
                                }`}
                                onClick={() => todayHandler(tab)}
                              >
                                {label}
                              </div>
                            );
                          })}
                    </div>
                  </div>
                )}
              </div>

              {isAktuelle && (
                <p className="date_aktelle">
                  {activeTab === "today"
                    ? todayDate
                    : activeTab === "tomorrow"
                    ? moment().add(1, "days").format("DD.MM.YYYY")
                    : moment()
                        .add(parseInt(activeTab.replace("day_", ""), 10), "days")
                        .format("DD.MM.YYYY")}
                </p>
              )}

              <div className="flex items-center">
                {isAktuelle && !isMobile && (
                  <div
                    className={` text_only ${
                      !expanded ? "active" : ""
                    } flex-shrink-0 mr-2`}
                    onClick={expandedHandler}
                  >
                    Alle Beschreibungen anzeigen
                  </div>
                )}

                {isAktuelle && isMobile && (
                  <i
                    onClick={expandedHandler}
                    title="Alle Beschreibungen anzeigen"
                    className={`icon-ns ns-descIcon${
                      !expanded ? "Green" : ""
                    } w-24 h-24 flex-shrink-0 cursor-pointer mr-2`}
                  ></i>
                )}

                {subHeader && (
                  <span className="mr-2 subheader">{subHeader}</span>
                )}
                <i
                  onClick={onClose}
                  className={`icon-ns ns-closeGray w-24 h-24 flex-shrink-0 cursor-pointer mr-1`}
                ></i>
              </div>
            </div>
          )}
          {children}
        </div>
      </div>
    );
  }
);

export default Modal;
